import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { Periode } from '@/models/periode.model'

export default {
  data () {
    return {
      loading: false,
      periode: new Periode(),
      errorMessage: ''
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    createPeriod () {
      this.errorMessage = ''
      this.loading = true
      this.$store.dispatch('periode/createPeriode', this.periode).then(
        response => {
          this.loading = false
          this.$router.push({ name: 'administration/periode/list' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response.data
        }
      )
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Création d\'une période'
    this.$store.state.filArianeMiddlePage = 'Liste des périodes'
    this.$store.state.filArianeMiddleRouterLink = 'administration/periode/list'
  },
  mounted () {
    var self = this
    $( function () {
      $('#datedebut').datepicker({
        onSelect: function (dateText) {
          self.periode.dateDebut = dateText
        }
      })
      $('#datefin').datepicker({
        onSelect: function (dateText) {
          self.periode.dateFin = dateText
        }
      })
      $('#dateEcheance4jours').datepicker({
        onSelect: function (dateText) {
          self.periode.dateEcheance4jours = dateText
        }
      })
      $('#dateEcheance30jours').datepicker({
        onSelect: function (dateText) {
          self.periode.dateEcheance30jours = dateText
        }
      })
      $('#dateEcheance60jours').datepicker({
        onSelect: function (dateText) {
          self.periode.dateEcheance4jours = dateText
        }
      })
    })

    this.errorMessage = ''
    this.loading = true
    this.$store.dispatch('periode/getDatesForPeriode').then(
      response => {
        var moment = require('moment')
        this.periode.dateDebut = moment(response.dateDebut).format('YYYY-MM-DD')
        this.periode.dateFin = moment(response.dateFin).format('YYYY-MM-DD')
        this.periode.dateEcheance4jours = moment(response.dateEcheance4jours).format('YYYY-MM-DD')
        this.periode.dateEcheance30jours = moment(response.dateEcheance30jours).format('YYYY-MM-DD')
        this.periode.dateEcheance60jours = moment(response.dateEcheance60jours).format('YYYY-MM-DD')
        this.periode.userUpdateLogin = this.$store.state.user.user.login
        this.loading = false
      },
      error => {
        this.loading = false
        this.errorMessage = error.response.data
      }
    )
  }
}
